const PriceDescription = ({ description }) => {
  if (!description) return null

  return (
    <span className="text-[#531dab] font-segoe text-xs font-normal max-w-[105px]">
      {description}
    </span>
  )
}

export default PriceDescription
